import { autoinject } from "aurelia-framework";
import { TravelRequestsListApi, TravelRequestsQueryFilter, TravelRequestsQueryRecord, TravelRequestsQueryType } from 'api/travel-requests-list';
import { QueryParams } from 'model/essential-types';
import { TravelRequestListQueryDTO, TravelRequestsClient } from 'api/swagger/ApiClient';
import { BusinessKeywordsMapping } from 'api/client/mapping/business-keywords-mapping';
import { EssentialTypesMapping } from 'api/client/mapping/essential-types-mapping';
import { HelpersMapping } from 'api/client/mapping/helpers-mapping';
import { EnumsService } from 'services/enums-service';

@autoinject
export class TravelRequestsListClientApi implements TravelRequestsListApi {
  constructor(private travelRequestsClient: TravelRequestsClient, private helpersMapping: HelpersMapping, private businessKeywordsMapping: BusinessKeywordsMapping, private essentialTypesMapping: EssentialTypesMapping, private enumsService: EnumsService) {
  }


  async queryTravelRequests(type: TravelRequestsQueryType, filter: TravelRequestsQueryFilter, params: QueryParams): Promise<TravelRequestsQueryRecord[]> {
    switch (type) {
      case TravelRequestsQueryType.Current: {
        return (await this.travelRequestsClient.getFutureForCurrentUser(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.statusValue, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapTravelRequestsQueryRecord(x));
      }
      case TravelRequestsQueryType.Past: {
        return (await this.travelRequestsClient.getPastForCurrentUser(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.statusValue, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapTravelRequestsQueryRecord(x));
      }
      case TravelRequestsQueryType.ForReview: {
        return (await this.travelRequestsClient.getToReviewForApprover(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.statusValue, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapTravelRequestsQueryRecord(x));
      }
      case TravelRequestsQueryType.Reviewed: {
        return (await this.travelRequestsClient.getReviewedForApprover(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.statusValue, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapTravelRequestsQueryRecord(x));
      }
      case TravelRequestsQueryType.All: {
        return (await this.travelRequestsClient.getAllForAdministrator(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.statusValue, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapTravelRequestsQueryRecord(x));
      }
    }
  }

  private mapTravelRequestsQueryRecord(dto: TravelRequestListQueryDTO): TravelRequestsQueryRecord {
    return {
      id: dto.id,
      name: dto.name,
      from: dto.startDate,
      to: dto.endDate,
      status: this.enumsService.approvalStatuses.find(x => x.value == dto.approvalStatus),
      statusDate: dto.approvalStatusChangeOn,
      countries: dto.countries.map(c => {
        return {
          country: this.businessKeywordsMapping.mapToCountry(c.country),
          status: this.enumsService.approvalStatuses.find(x => x.value == c.approvalStatus)
        }
      }),
      travelers: dto.travellersAndContractors.map(t => this.essentialTypesMapping.mapPersonInfoToPersonInfo(t)),
      isActive: dto.isActive
    }
  }
}
